import SchemeDetailsField from './SchemeDetailsField'

export default SchemeDetailsField
